import React from "react";
import { Modal, Text, TouchableOpacity, View, ViewProps } from "react-native";
import { styles } from "./style";

interface ISlideModalProps {
  style?: ViewProps;
  headChildren?: React.ReactNode;
  dismissCallback?: () => void;
  contentHeight: number;
  closeText: string;
  children?: React.ReactNode;
}

export const SlideModal: React.FC<ISlideModalProps> = ({
  style,
  headChildren,
  dismissCallback,
  closeText,
  children,
  contentHeight,
}) => {
  const css = styles();

  return (
    <Modal transparent>
      <View style={[css.wrapper, style]}>
        <View style={[css.background, { opacity: 0.6 }]} />
        <View
          style={[
            css.content,
            {
              transform: [
                {
                  translateY: -contentHeight,
                },
              ],
              height: contentHeight,
            },
          ]}
        >
          <View>
            <TouchableOpacity
              style={css.topIndicator}
              onPress={dismissCallback}
            />
            <View style={css.header}>
              {headChildren}
              <Text style={css.close} onPress={dismissCallback}>
                {closeText}
              </Text>
            </View>
          </View>
          {children}
        </View>
      </View>
    </Modal>
  );
};
